export default __webpack_public_path__ + "static/media/docext-run.8f5ce440.gif";